/*global Modernizr, tec_get_percentageSeen */
/*jslint browser:true */

function tec_get_percentageSeen(element) {
  'use strict';

  // Get the relevant measurements and positions
  const viewportHeight = window.innerHeight;
  const bounds = element.getBoundingClientRect();
  const elementOffsetTop = bounds.y;
  const elementHeight = element.offsetHeight;

  // Calculate percentage of the element that's been seen
  const distance = viewportHeight - elementOffsetTop;
  const percentage = Math.round(
    distance / ((elementHeight) / 100)
  );

  // Restrict the range to between 0 and 100
  return Math.min(100, Math.max(0, percentage));
}